export default "__VITE_ASSET__D2HW2fd9__"